"use client";
import { CampaignBooks as CampaignBooksType } from "@cappelendamm/e-commerce-services";
import Image from "next/image";
import { Card, Typography } from "@cappelendamm/design-system/react";

type CampaignBooksProps = {
  campaignBooks: CampaignBooksType;
};

export const CampaignBooks = ({ campaignBooks }: CampaignBooksProps) => {
  return (
    <div className="space-y-2">
      <Typography variant="title-md" as="h3" className="text-center">
        Bøker i kampanjen
      </Typography>

      <Card className="grid w-full divide-y px-4">
        {campaignBooks.map((book, index) => (
          <div
            key={book.sku ?? `${book.name ?? "campaign-book"}-${index}`}
            className="flex items-center gap-4 px-2 py-4"
          >
            {book?.image && (
              <Image
                src={book.image}
                height={70}
                width={48}
                alt={book.name ?? ""}
              />
            )}
            <span className="space-y-1 self-center">
              <Typography variant="title-sm">{book?.name}</Typography>
              <Typography variant="body-sm" className="text-gray-800">
                Bok {book?.numberInSeries ?? ""}
              </Typography>
            </span>
          </div>
        ))}
      </Card>
    </div>
  );
};
